import { rotasSGI } from "@/views/SGI";
import rotasProduto from "@/views/Produto/produtoRotas";
import { posVendasRotas as rotasPosVendas } from "@/views/PosVendas";
import { creObrasRotas } from "@/views/CREObras";
import { rotaContratoAberta } from "@/views/Contratos";
import { rotaSemObra } from "@/views/Materiais";
import { rotaJuridico } from "@/views/Juridico";
import { rotasContratosAutomacao } from "./ContratosAutomacao";
import { rotasApontamento } from "@/views/Apontamentos";
import { rotaObras, rotasObraDashboards, rotasObraGeral } from "@/views/Obra/obraRotas";
import { rotaBibliotecaGali } from "@/views/Biblioteca";
import {
  rotaPerfil,
  rotasGrupos,
  rotasEditorGrupo,
  rotaAtribuirAcesso,
} from "@/views/ControleAcesso";
import { rotasSeguros } from "./Seguros";
import { rotaHome, rotaVersoesSistema } from "@/views/Geral";

// Reexportadas porque `router/index.ts` e o agregador as consomem por este
// caminho desde antes da T88; o move foi de arquivo, nao de contrato.
export { rotaHome, rotaVersoesSistema };

// Wrapper "aberta" (LayoutGeralAberto): mistura rotas de Obra e de Geral sob
// um unico layout publico. Preservado como estava — separar por dominio e
// mudanca estrutural fora do escopo de T13 (R11).
export const rotasAbertasGeral = [
  {
    path: "/teste",
    layoutNome: "LayoutGeralAberto",
    component: () => import("@/layout/LayoutGeral.vue"),
    meta: {
      showMenu: false,
    },
    children: [...rotaObras, ...rotaVersoesSistema, ...rotasObraDashboards],
  },
];

// Wrapper "restrita" (LayoutGeral): idem, hospeda varios dominios sob o
// mesmo layout. Preservado como estava (R11).
export const rotasRestritasGeral = [
  {
    path: "",
    layoutNome: "LayoutGeral",
    component: () => import("@/layout/LayoutGeral.vue"),
    meta: {
      showMenu: false,
    },
    children: [
      ...rotaPerfil,
      ...rotasGrupos,
      ...rotasEditorGrupo,
      ...rotaAtribuirAcesso,
      ...rotaBibliotecaGali,
      ...rotasObraGeral,
      ...rotasSeguros,
      ...rotasSGI,
      ...rotasProduto,
      ...rotasPosVendas,
      ...rotaContratoAberta,
      ...creObrasRotas["geral"],
      ...rotaSemObra,
      ...rotaJuridico,
      ...rotasApontamento,
      ...rotasContratosAutomacao,
    ],
  },
];
